/// <reference path="../include.ts" />

namespace gpx_visualizer_phase2 {

	export enum SentryLevel {
		Fatal    = 'fatal',
		Error    = 'error',
		Warning  = 'warning',
		Log      = 'log',
		Info     = 'info',
		Debug    = 'debug',
		Critical = 'critical',
	}
}
